const TOGGLE_MENU = 'TOGGLE_MENU';
const SHOW_MENU = 'SHOW_MENU';
const HIDE_MENU = 'HIDE_MENU';

export function toggleAppNavMenu() {
    return {
        type: TOGGLE_MENU
    };
}

export function showAppNavMenu() {
    return {
        type: SHOW_MENU
    };
}

export function hideAppNavMenu() {
    return {
        type: HIDE_MENU
    };
}

const initialState = {
    isVisible: false
};

export default function appnavmenu(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_MENU:
            return {
                ...state,
                isVisible: !state.isVisible
            };

        case SHOW_MENU:
            return {
                ...state,
                isVisible: true
            };

        case HIDE_MENU:
            return {
                ...state,
                isVisible: false
            };

        default:
            return state;
    }
}
